import { defineAsyncComponent } from 'vue'
export default {
  articles: defineAsyncComponent(() => import("/app/layouts/articles.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/app/layouts/dashboard.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/layouts/error.vue").then(m => m.default || m)),
  "generation-contenus": defineAsyncComponent(() => import("/app/layouts/generation-contenus.vue").then(m => m.default || m)),
  users: defineAsyncComponent(() => import("/app/layouts/users.vue").then(m => m.default || m))
}